import { notification } from "antd";
import { useMutation, useQuery } from "react-query";
import { GET, POST } from "../../../../Services";

export const usePokedexUsuarioTable = (params = null) => {
    return useQuery(
        ["pokedexUsuarioTable", params],
        async () => {
            const searchParams = new URLSearchParams({
                usua_id: params?.usua_id,
                page: params?.page ?? 1,
                perPage: params?.perPage ?? 10,
            }).toString();
            const response = await GET(
                "pokedex/pokedexTable",
                searchParams ? `?${searchParams}` : ""
            );
            return response;
        },
        {
            enabled: !!params,
            retry: 0,
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            onError: (error) => {
                notification["error"]({
                    message: "Error al cargar la tabla de pokedex",
                });
            },
        }
    );
};

export const useCrearPokedexUsuario = () => {
    return useMutation(async (data) => await POST(data, "pokedex/agregarPokedex"), {
        onSuccess: () => {
            notification["success"]({ message: "Pokemon agregado a la pokedex correctamente" });
        },
        onError: (error) => {
            if (error.response && error.response.data?.mensaje) {
                notification["error"]({ message: error.response.data.mensaje });
            } else {
                notification["error"]({ message: "Error al agregar pokemon a la pokedex" });
            }
        },
    });
};

export const useEditarPokedexUsuario = () => {
    return useMutation(async (data) => await POST(data, "pokedex/editarPokedex"), {
        onSuccess: () => {
            notification["success"]({ message: "Registro de pokedex editado correctamente" });
        },
        onError: (error) => {
            if (error.response && error.response.data?.mensaje) {
                notification["error"]({ message: error.response.data.mensaje });
            } else {
                notification["error"]({ message: "Error al editar registro de pokedex" });
            }
        },
    });
};

export const useEliminarPokedexUsuario = () => {
    return useMutation(async (data) => await POST({ idPokedex: data.id }, "pokedex/eliminarPokedex"), {
        onSuccess: () => {
            notification["success"]({ message: "Registro de pokedex eliminado correctamente" });
        },
        onError: (error) => {
            if (error.response && error.response.data?.mensaje) {
                notification["error"]({ message: error.response.data.mensaje });
            } else {
                notification["error"]({ message: "Error al eliminar registro de pokedex" });
            }
        },
    });
};